import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { StatusCode, type Customer, REACT_QUERY_KEYS } from '@hungryroot/rest';
import { getCustomerSelf } from '@hungryroot/rest/api/v2/customers/self/get';

type OptionType = Omit<
  UseQueryOptions<
    Customer,
    unknown,
    Customer,
    (
      | number
      | 'self'
      | Record<string, string | number | boolean | string[]>
      | REACT_QUERY_KEYS
      | undefined
    )[]
  >,
  'queryFn' | 'queryKey'
>;

export function useCustomerHook(
  id: number | 'self',
  options: OptionType,
  query?: Record<string, string | number | boolean | string[]>
) {
  return useQuery({
    queryKey: [REACT_QUERY_KEYS.CUSTOMERS, id, query],
    queryFn: async () => {
      const resp = await getCustomerSelf();

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp, null, 2));
      }

      return resp.data;
    },
    ...options,
    enabled: options.enabled === false || id === 0 ? false : true,
    gcTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    retryOnMount: false,
    staleTime: 5 * 60 * 1000,
    retry: 0,
  });
}
